import { Colleague, ColleagueDetails } from "features/colleague-portal/aboutMe";
import { getColleagueDetails } from "features/colleague-portal/aboutMe/api/getColleagueDetails";
import { createContext, useCallback, useEffect, useState } from "react";
import storage from "utils/storage";

type ColleagueDetailsContextType = {
  colleagueDetails?: ColleagueDetails; // optional
  setColleagueDetails: React.Dispatch<
    React.SetStateAction<ColleagueDetails | undefined>
  >;
  fetchColleagueDetails: () => Promise<void>;
};

export const ColleagueDetailsContext =
  createContext<ColleagueDetailsContextType>({
    colleagueDetails: undefined,
    setColleagueDetails: () => {},
    fetchColleagueDetails: async () => {},
  });

export const ColleagueDetailsProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [colleagueDetails, setColleagueDetails] = useState<ColleagueDetails>();
  const token = storage.getToken();

  const fetchColleagueDetails = useCallback(async () => {
    try {
      const response = await getColleagueDetails();

      setColleagueDetails(response);
    } catch (error) {
      console.error("Error fetching colleague details:", error);
    }
  }, []);

  useEffect(() => {
    if (!token) return;

    fetchColleagueDetails();

    const interval = setInterval(fetchColleagueDetails, 1800000); // 30 minutes
    return () => clearInterval(interval); // cleanup
  }, [fetchColleagueDetails, token]);
  return (
    <ColleagueDetailsContext.Provider
      value={{ colleagueDetails, setColleagueDetails, fetchColleagueDetails }}
    >
      {children}
    </ColleagueDetailsContext.Provider>
  );
};
